/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import PropTypes from 'prop-types';

import {
  ComponentPropShape,
  SystemPropertyShape
} from 'app/common/constants/CommonProps';

export default {
  components: PropTypes.shape({
    HeaderActionComponents: PropTypes.func.isRequired,
    CreateAccount: PropTypes.func.isRequired,
    UpdateAccount: PropTypes.func.isRequired
  }).isRequired,
  contextParams: PropTypes.shape({
    /** alias for `accountId` */
    id: PropTypes.string,
    /** the the account ID */
    accountId: PropTypes.string,
    /**  alias for `property` */
    parent: SystemPropertyShape,
    /** the account ID System Property's data */
    property: SystemPropertyShape,
    /** tracking parameters */
    tracking: PropTypes.shape({
      applicationId: PropTypes.string,
      catalog: PropTypes.shape({
        /** list of catalogs assigned to the current site */
        assignedCatalogs: PropTypes.arrayOf(PropTypes.object),
        /** the currently selected catalog, can be null for Production catalog */
        currentCatalogId: PropTypes.string,
        /** */
        setCurrentCatalogById: PropTypes.func
      }),
      sandbox: PropTypes.shape({
        /** the currently selected sandbox, can be null for Production sandbox */
        currentSandboxId: PropTypes.string,
        /** */
        setCurrentSandboxById: PropTypes.func,
        /** list of sandboxes available for the current user */
        userSandboxes: PropTypes.arrayOf(PropTypes.object)
      }),
      tenantId: PropTypes.string
    })
  }),
  dispatch: PropTypes.func.isRequired,
  metadata: ComponentPropShape.isRequired,
  state: PropTypes.shape({
    data: SystemPropertyShape,
    fetchError: PropTypes.shape({
      data: PropTypes.any,
      message: PropTypes.string,
      stack: PropTypes.string,
      type: PropTypes.symbol
    }),
    isFetching: PropTypes.bool.isRequired,
    isFetchError: PropTypes.bool.isRequired,
    isFetchQueued: PropTypes.bool.isRequired,
    lastUpdated: PropTypes.number
  })
};
